<template>
    <v-app style="background-color: #ececec;">
      <BaseMitLoading :show="loading" :message="loadingMessage" :progressSize="loadingSize" :progressBar="loadingProgressBar"/>
      <div v-if="!siteLoading">
        <BaseMitHeader class="doNotPrint" :userModel="userModel" :userRoles="userRoles" v-on:logout="logout" v-on:login="login" />
        <BaseMitAppNavigation class="doNotPrint" v-show="this.$vuetify.breakpoint.smAndDown == false" v-if="userModel" :userModel="userModel" :userRoles="userRoles" v-on:logout="logout" v-on:login="login"/>

        <v-main  :class="{'pl-0': $vuetify.breakpoint.smAndDown, 'pt-10':$vuetify.breakpoint.smAndDown==false}">
            <router-view></router-view>
        </v-main>
      </div>
    </v-app>
</template>

<script>
import axios from 'axios';

import BaseMitLoading from './base/components/BaseMitLoading.vue';
import BaseMitHeader from './base/components/BaseMitHeader.vue';
import BaseMitMenu from './base/components/BaseMitMenu.vue';
import BaseMitAppNavigation from './base/components/BaseMitAppNavigation.vue';
import BaseMitUserModel from './base/models/BaseMitUserModel.js';
import BaseMitUserService from './base/services/BaseMitUserService.js';
import BaseMitRequestInterceptorService from './base/services/BaseMitRequestInterceptorService.js';
import {MitEventBus} from './main.js';

export default {
  name: 'app',
  components: {
    BaseMitLoading,
    BaseMitHeader,
    BaseMitMenu,
    BaseMitAppNavigation
  },
  data: function() {
    return {
      siteLoading:true,
      loading:false,
      loadingProgressBar:false,
      loadingMessage:'Loading...',
      loadingSize:88,
      userModel:null,
      userRoles:BaseMitUserModel.ROLES,
      requestInterceptor:null
    }
  },
  mounted() {
    MitEventBus.$on('mit-pageloadingservice--loading-changed', this.updateLoading);
  },
  created() {
    //create a request interceptor to handle 401 and 403 app wide
    this.requestInterceptor = new BaseMitRequestInterceptorService(BaseMitUserService,this.$router);

    //Ensure the default calls are successful before proceding
    //Might be better to move to main.js with the config
    BaseMitUserService.getUser()
      .then((result) => {
        this.userModel = result;//values from second promise
        this.siteLoading = false;
        this.updateLoading({loading:false});
      })
      .catch((error) => {
        this.siteLoading = false;
        this.updateLoading({loading:false});
      });
  },
  methods: {
    updateLoading(loadingModel) {
      this.loading = loadingModel.loading;
      this.loadingMessage = loadingModel.message;
      this.loadingSize = loadingModel.loadingSize;
      this.loadingProgressBar = loadingModel.loadingProgressBar;
    },
    login() {
        BaseMitUserService.login();
    },
    logout() {
      window.location.href = '/auth/logout';
    }
  }
}
</script>

<style lang="scss">
//Entire site font override
// .v-application {
// 	font-family: monospace !important;
// }

.mit-loading-page {
  height:100vh;
}
</style>
